.card {
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  box-sizing: border-box;
}

.input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  /* 16px, not 15: below 16 iOS Safari zooms the page into a focused field, and the viewport no
     longer forbids zoom (BUG-11) — the sheet would stay zoomed and clipped after blur. */
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.input:focus {
  border-color: rgba(204, 255, 0, 0.6);
}

.inputInvalid {
  border-color: rgba(255, 60, 60, 0.7);
}

.inputInvalid:focus {
  border-color: rgba(255, 60, 60, 0.9);
}

.warning {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 170, 0, 0.12);
  border: 1px solid rgba(255, 170, 0, 0.4);
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
}

.success {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(204, 255, 0, 0.1);
  border: 1px solid rgba(204, 255, 0, 0.35);
}

.linkButton {
  background: transparent;
  border: none;
  min-height: var(--gac-control-touch-target);
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  align-self: center;
}
